import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Sites from './pages/Sites'
import ErrorPage from "./pages/ErrorPage";
import Partners from "./pages/PartnersPage";
import Contacts from "./pages/ContactsPage";
import About from "./pages/AboutPage";
import Frameworks from "./pages/Frameworks";
import RaytolfasToastify from "./pages/RaytolfasToastify";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/about" element={<About />} />
        <Route path="/frameworks" element={<Frameworks />} />
        <Route path="/framework/raytolfas_toastify" element={<RaytolfasToastify />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
